import { render, staticRenderFns } from "./DestinationStoreButton.vue?vue&type=template&id=6d496f23&scoped=true&"
import script from "./DestinationStoreButton.vue?vue&type=script&lang=js&"
export * from "./DestinationStoreButton.vue?vue&type=script&lang=js&"
import style0 from "./DestinationStoreButton.vue?vue&type=style&index=0&id=6d496f23&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d496f23",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VCard,VImg})
